import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { FacilityInvitationPdfsApi } from '../../../apis/InvitationApi/FacilityInvitationPdfsApi.ts';
import { uploadFileToS3 } from '../../../helpers/uploadFileToS3.ts';

interface UploadInvitationPdfVars {
    facilityId: number;
    language: string;
    file: File;
}

export function useUploadFacilityInvitationPdf() {
    const queryClient = useQueryClient();
    const { t } = useTranslation();
    return useMutation<void, AppMedError, UploadInvitationPdfVars>({
        mutationKey: [QueryKeys.facilityInvitationPdfs, 'upload'],
        mutationFn: async ({ facilityId, language, file }) => {
            const policy = await FacilityInvitationPdfsApi.getUploadUrl(
                facilityId,
                language,
                encodeURIComponent(file.name),
            );
            await uploadFileToS3(policy, file);
        },
        onSuccess: (_data, vars) => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.facilityInvitationPdfs, vars.facilityId],
            });
            notifications.show({
                color: 'green',
                message: t('invitationPdf.admin.uploaded'),
            });
        },
        onError: (err) => {
            notifications.show({ color: 'red', message: err.message });
        },
    });
}
